import { ExternalLink } from 'lucide-react'
import { forwardRef, type CSSProperties } from 'react'

import { SIDEBAR_TEST_IDS } from '@/constants/testIds'
import { EXTERNAL_URLS } from '@/routes/paths'

import { MenuItem } from './MenuItem'

interface SubPanelProps {
  style?: CSSProperties
  onMouseEnter: () => void
  onMouseLeave: () => void
  onCookieSettings: () => void
  termsOfServicePath: string
}

export const SubPanel = forwardRef<HTMLDivElement, SubPanelProps>(function SubPanel(
  { style, onMouseEnter, onMouseLeave, onCookieSettings, termsOfServicePath },
  ref,
) {
  return (
    <div
      ref={ref}
      className="sidebar-profile-menu__sub-menu"
      style={style}
      role="menu"
      aria-label="Privacy & Terms"
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <MenuItem
        label="Terms of Service"
        href={termsOfServicePath}
        trailingIcon={<ExternalLink size={20} />}
        data-testid={SIDEBAR_TEST_IDS.PROFILE_MENU_TERMS_OF_SERVICE}
      />
      <MenuItem
        label="Privacy Policy"
        href={EXTERNAL_URLS.PRIVACY_POLICY}
        trailingIcon={<ExternalLink size={20} />}
        borderBottom
        data-testid={SIDEBAR_TEST_IDS.PROFILE_MENU_PRIVACY_POLICY}
      />
      <MenuItem
        label="Cookie Settings"
        onClick={onCookieSettings}
        data-testid={SIDEBAR_TEST_IDS.PROFILE_MENU_COOKIE_SETTINGS}
      />
    </div>
  )
})
